import React from 'react'
import { useTranslation } from 'react-i18next'

const TicketCalendarNotFound: React.FC = () => {
  const { t } = useTranslation('common')

  const base = 'ticket-calendar'

  return <div className={`${base}__not-found`}>{t('dataNotFound.label')}</div>
}

export default TicketCalendarNotFound
